// extracted by mini-css-extract-plugin
module.exports = {"cargando":"Renglones_cargando__2nK5B"};